"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const react_hooks_1 = require("@apollo/react-hooks");
const ActionButtons_1 = __importDefault(require("coact/pages/modules/pageAction/ActionButtons"));
const react_router_1 = require("react-router");
const DoAssertionView_1 = __importDefault(require("../DoAssertionView"));
const AssertionInfoStatus_1 = require("../../../assertion/AssertionInfoStatus");
const GET_ASSERT_INFO = graphql_tag_1.default `
  query getAssertInfo($id: String!) {
    getAssertionInfo(id: $id) {
      id
      status
      warehouse {
        name
      }
      startDate
    }
  }
`;
const START_ASSERT = graphql_tag_1.default `
  mutation startAssert($id: String!) {
    startAssertionInfo(id: $id)
  }
`;
const DELETE_ASSERTION_INFO = graphql_tag_1.default `
  mutation deleteAssertionInfo($id: String!) {
    deleteAssertionInfo(id: $id)
  }
`;
function AssertionInfoView(props) {
    const assertionInfoId = props.match.params.id;
    const [startAssert, { loading: startAsserting }] = react_hooks_1.useMutation(START_ASSERT, {
        variables: {
            id: assertionInfoId,
        },
    });
    const [deleteAssertionInfo] = react_hooks_1.useMutation(DELETE_ASSERTION_INFO);
    const { loading, data, refetch } = react_hooks_1.useQuery(GET_ASSERT_INFO, {
        variables: { id: props.match.params.id },
    });
    if (loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (data !== undefined
        && data.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Deleted) {
        return react_1.default.createElement(react_router_1.Redirect, { to: props.rootPath });
    }
    const actions = [
        {
            text: '返回',
            props: {},
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                props.history.push(props.rootPath);
            }),
        },
    ];
    const deleteAction = {
        text: '刪除盤點單',
        props: {},
        onClick: () => __awaiter(this, void 0, void 0, function* () {
            yield deleteAssertionInfo({
                variables: {
                    id: assertionInfoId,
                },
            });
            refetch();
        }),
    };
    const status = data === undefined ? null : data.getAssertionInfo.status;
    if (status === AssertionInfoStatus_1.AssertionInfoStatus.Created) {
        actions.push({
            text: '開始盤點',
            props: {},
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                if (!startAsserting) {
                    yield startAssert();
                    refetch();
                }
            }),
        });
    }
    if (status === AssertionInfoStatus_1.AssertionInfoStatus.Created
        || status === AssertionInfoStatus_1.AssertionInfoStatus.Cancelled) {
        actions.push(deleteAction);
    }
    const AssertView = () => {
        if (data === undefined
            || data.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Created
            || data.getAssertionInfo.status === AssertionInfoStatus_1.AssertionInfoStatus.Cancelled) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        return react_1.default.createElement(DoAssertionView_1.default, Object.assign({}, props));
    };
    const importForm = status === AssertionInfoStatus_1.AssertionInfoStatus.Created
        ? (react_1.default.createElement("form", { action: "/api/route/assertManagementUpload", method: "post", encType: "multipart/form-data" },
            react_1.default.createElement("hr", null),
            "\u532F\u5165\u76E4\u9EDE\u55AE\uFF1A \u8A8D\u5217\u65BC",
            react_1.default.createElement("input", { type: "text", name: "year", id: "year", maxLength: 4, size: 4 }),
            "\u5E74",
            react_1.default.createElement("input", { type: "text", name: "month", id: "month", maxLength: 2, size: 2 }),
            "\u6708",
            react_1.default.createElement("input", { type: "text", name: "day", id: "day", maxLength: 2, size: 2 }),
            "\u65E5",
            react_1.default.createElement("input", { type: "hidden", name: "id", value: assertionInfoId }),
            react_1.default.createElement("input", { type: "file", name: "upload_input", id: "upload_input" }),
            react_1.default.createElement("input", { type: "hidden", name: "url", id: "url", value: window.location.href }),
            react_1.default.createElement("input", { type: "submit", value: "\u4E0A\u50B3\u76E4\u9EDE\u8CC7\u6599" })))
        : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ActionButtons_1.default, { actions: actions, classes: null }),
        importForm,
        react_1.default.createElement(AssertView, null)));
}
exports.default = AssertionInfoView;
